import {
  GetGoogleDriveFilesDto,
  GoogleDriveAccount,
  GoogleDriveAuthUrl,
  GoogleDriveFiles,
  GoogleDriveFilesSearchQueryResult
} from 'shared/interfaces/GoogleDrive';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const googleDriveBaseEndpoint = '/google-drive';

export const GoogleDriveService = {
  getAccounts: async (): Promise<GoogleDriveAccount[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${googleDriveBaseEndpoint}/accounts`
    });

    return response.data;
  },

  getAuthUrl: async (): Promise<GoogleDriveAuthUrl> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${googleDriveBaseEndpoint}/auth-url`
    });

    return response.data;
  },

  registerAccount: async (code: string): Promise<GoogleDriveAccount> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${googleDriveBaseEndpoint}/register-account`,
      data: { code }
    });

    return response.data;
  },

  deleteAccount: async (googleDriveAccountId: string): Promise<GoogleDriveAccount> => {
    const response = await axiosBaseInstance({
      method: 'delete',
      url: `${googleDriveBaseEndpoint}/accounts/${googleDriveAccountId}`
    });

    return response.data;
  },

  getFiles: async (getGoogleDriveFilesDto: GetGoogleDriveFilesDto): Promise<GoogleDriveFilesSearchQueryResult> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${googleDriveBaseEndpoint}/files`,
      params: getGoogleDriveFilesDto
    });

    return response.data;
  },

  getGoogleDriveFilesTextData: async (resourceId: string): Promise<GoogleDriveFiles> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${googleDriveBaseEndpoint}/text-data`,
      params: { resourceId }
    });

    return response.data;
  }
};
